import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import { urlModifier } from 'swag-client-common/libs/url-modifier';
import classes from '../categories-links/categories-links.scss';
export function CategoryLinkComponent({
  currentRoute,
  onLinkClick,
  isViolet,
  category,
  handleMouseEnter,
  hoverCategoryId
}) {
  const {
    _id,
    isActive,
    link,
    name
  } = category;
  return /*#__PURE__*/React.createElement(Link, {
    key: _id,
    to: currentRoute ? urlModifier(`/${currentRoute}/${link}`) : urlModifier(`/${link}`),
    onClick: onLinkClick,
    className: classnames(classes.menuItem, {
      [classes.activeMenuItem]: isActive || hoverCategoryId === _id,
      [classes.violet]: isViolet
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.linkName
  }, /*#__PURE__*/React.createElement("span", {
    onMouseEnter: handleMouseEnter,
    "data-id": _id,
    className: classes.text
  }, name)));
}